<script setup lang="ts">
import ModalWithButtons from '@/components/Modal/ModalWithButtons.vue'
import TeamTrialButton from '@/components/TeamTrialButton .vue'
const emits = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <ModalWithButtons @close="emits('close')">
    <template #title> チームの日程調整を効率化 </template>
    <template #description>
      <div class="lo-v-end">
        <slot name="description" />
      </div>
    </template>
    <template #contents>
      <TeamTrialButton />
    </template>
  </ModalWithButtons>
</template>
